import { Leaf } from 'lucide-react';

interface AppLogoProps {
    className?: string;
}

export default function AppLogo({ className = '' }: AppLogoProps) {
    return (
        <>
            <div
                className={`flex size-8 items-center justify-center rounded-lg bg-green-500/10 text-green-500 ${className}`}
            >
                <Leaf className="h-5 w-5" />
            </div>
        </>
    );
}
